export enum NOTIFICATIONTYPE {
    SUCCESS = 'NOTIFICATIONTYPE_SUCCESS',
    LOADING = 'NOTIFICATIONTYPE_LOADING',
    ERROR   = 'NOTIFICATIONTYPE_ERROR'
}